"use strict";
var ACC;
ACC.storefinder = {
	_autoload: [
		["initStoreFinderComponent", $("#storeFinderForm").length],
		["initStoreListComponent", $("#storeFinderForm").length && $("#storeFinderList").length],
		["initStoreFinderPage", $(document.body).hasClass("page-storefinderPage") && $("#storeFinderForm").length ] // Quickfix: Added $("#storeFinderForm").length to prevent initStoreFinderPage running on Store Details page which is incorrectly reporting itself as a Store Finder page.
	],

	// Add your constants here.
	_constants: {
		CHAIN_ID_HOMESENSE: "21",
		CHAIN_ID_TKMAXX: "20",
		CLASS_CHECKED: "checked",
		CLASS_CONCEALED: "concealed",
		CLASS_MARKER_HOLDER: "gmapMarkerHolder",
		CLASS_MARKER_LABEL: "gmapmarker",
		CLASS_SHOW_MORE_STORES: "showMoreStores",
		CLASS_SHOW_MORE_DONE: "allShowing",
		INFO_WINDOW_ID: "gmapwindow",
		CLASS_FILTERED: "filtered",
		CLASS_REVEALED: "revealed",
		CLASS_VISIBLE: "visible",
		FILTER_CLICK_AND_COLLECT: "clickAndCollect",
		FILTER_HOMESENSE_STORE: "homesense",
		FILTER_TKMAXX_STORE: "tkmaxx",
		FOLDER_IMAGES: "/_ui/responsive/common/images/storeFinder/",
		SELECTOR_FILTER_CLICKANDCOLLECT: "#storeFinderClickAndCollect",
		SELECTOR_FILTER_HOMESENSE: "#storeFinderHomesenseOnly",
		SELECTOR_FILTER_TKMAXX: "#storeFinderTkMaxxOnly",
		SELECTOR_HEADER: ".main-header",
		SELECTOR_INTERNATIONAL_STORE_FORM: "#internationalStorefinderForm",
		SELECTOR_STORE_FINDER_ERROR: "#storeFinderFormError",
		SELECTOR_STORE_FINDER_FORM: "#storeFinderForm",
		SELECTOR_STORE_FINDER_FILTERS: "#storeFinderFilters",
		SELECTOR_STORE_FINDER_NEARME: "#findStoresNearMe",
		SELECTOR_STORE_MAP: "#storeFinderMap",
		SELECTOR_STORES_LIST: "#storeFinderList",
		URL_GOOGLE_DIRECTIONS: "https://www.google.com/maps/dir/Current+Location/"
	},

	// Populate on the fly for cached items such as multiple use jQuery look-ups.
	_cache: {
		coords: null, // Stores location coordinates.
		gmap: null, // Will hold Map instance.
		gmapmarkers: new Array(), // Will hold Map point markers.
		stores: {}, // Will hold retrieved data.
		storesDataUrl: "", // Set inside init
		storesresults: 0, // Will hold retrieved number from data.
		storeSearchExtraParams: "", // Added to address new requirement of passing params such as "criteria=cc" for CandC
		text: {} // Populated on the fly to hold JSP text from properties.
	},

	_fetchingStores: null,

	_pagginationPadding: 1,

	options: {
		storesListViewLimit: 6, // Restrict how many stores are shown in the list for lookup response.
		storesResultsPreFilter: function() { // Used to alter returned data before anything else happens.
			// console.log("cache.stores from response: ", cache.stores);
			// console.log("cache.storesresults from response: ", cache.storesresults);
		}
	},

	// Will hold calculated stats from received store data (see updateStatsFromStores).
	stats: {
		candc: {},
		stores: {}
	},

	// Will be used to record filter control state.
	view: {
		candc: false,
		homesense: true,
		tkmaxx: true
	},

	// What you need to initialise the Store Finder functionality.
	// This allows you to inject the form and list elements on any
	// page and use it as a component (outside original Store Finder page).
	initStoreFinderComponent: function() {
		var SF = ACC.storefinder;
		var c = SF._constants;
		var cache = SF._cache;
		cache.storesDataUrl = $(c.SELECTOR_STORE_FINDER_FORM).attr("action");

		this.cacheStoreFinderFormElements();
		this.bindStoreFinderFormEvents();
		this.resetStoreFinderComponentView();

		// Broadcast when completed
		$(document).trigger("ACC.storefinder.initStoreFinderComponent.complete");
	},

	// What you need to initialise the Store List functionality.
	initStoreListComponent: function() {
		this.cacheStoreListElements();
		this.bindStoreListViewEvents();

		// Broadcast when completed
		$(document).trigger("ACC.storefinder.initStoreListComponent.complete");
	},

	// Should only run on Store Finder page.
	initStoreFinderPage: function() {
		var SF = ACC.storefinder;
		var cache = SF._cache;

		this.cacheStoreFinderPageElements();
		this.bindFindInternationalStores();
		this.bindMapViewEvents();

		if (cache.$filterContainer.length) {
			this.bindFilterEvents();
		}

		SF.resetFilterView();
		SF.autoSearch();
		ACC.global.referrer("storefinder");

		// Event is triggered on AJAX response.
		cache.$storeFinderForm.on("response", function() {
            SF.updateStatsFromStores();
            SF.resetFilterView();
        });
    },

    applyAllFilters: function() {
        var SF = ACC.storefinder;
        var c = SF._constants;
        SF.applyFilter(c.FILTER_TKMAXX_STORE);
        SF.applyFilter(c.FILTER_HOMESENSE_STORE);
    },

	// Grab anything that will be used for the Store Finder Form.
	cacheStoreFinderFormElements: function() {
		var cache = ACC.storefinder._cache;
		var c = ACC.storefinder._constants;

		cache.$storeFinderForm = $(c.SELECTOR_STORE_FINDER_FORM);
		cache.$findStoresNearMe = $(c.SELECTOR_STORE_FINDER_NEARME);
		cache.$storeFinderFormError = $(c.SELECTOR_STORE_FINDER_ERROR);

		// First add any text detected in JSP in cache.text
		ACC.global.setDataElementText(cache.text, cache.$storeFinderFormError);
	},

	bindStoreFinderFormEvents: function() {
		var SF = ACC.storefinder;
		var cache = SF._cache;
		SF.cacheStoreFinderPageElements();

		cache.$findStoresNearMe.on("click", function(e) {
			if (window.location.href.indexOf("store-finder") === -1){
				ACC.gtm.trackCheckoutStepOptions('1', 'Find Store Near Me');
			}
			e.preventDefault();
			SF.getStoreDataByCoords();
			SF.resetStoreFinderComponentView();
			$(".storefinder-error").hide();
			cache.$filterContainer.show();
		});

		cache.$storeFinderForm.on("submit", function(e) {
			e.preventDefault();
			SF.getStoreDataByEntry();
			SF.resetStoreFinderComponentView();
			$(".storefinder-error").hide();
			cache.$filterContainer.show();
			$("#storelocator-query").blur();
		});

		cache.$storeFinderForm.on("response", function() {
			// This will trigger when submit (AJAX get stores data).
			// has successfully returned. You can bind to this event
			// elsewhere, exactly the same as using something like
			// $storeFinderForm.on("submit", someOtherFunction);
			// Try not to pollute this main event with anything page-specific.

			// Uncomment next line for testing.
			SF.options.storesResultsPreFilter();

			// Repopulate errors with locaiton.
			$(".location-value").text(cache.location);
		});
	},

	// Initialise view state before each search.
	resetStoreFinderComponentView: function () {
		var SF = ACC.storefinder;
		var cache = SF._cache;
		cache.$storeFinderFormError.hide();
	},

	// Grab anything that will be used for the Store List.
	cacheStoreListElements: function() {
		var SF = ACC.storefinder,
            cache = SF._cache,
            c = SF._constants,
            $container = $(c.SELECTOR_STORES_LIST),
            reporter;

		// First add any text detected in JSP in cache.text
		ACC.global.setDataElementText(cache.text, $container);

		// Set initial state of storelist.
		cache.storelist = {
			start: 1,
			end: 0,
			total: 0,
			location: ""
		};

		cache.storelist.$container = $container;
		cache.storelist.$control = SF.createListMoreControl();

		reporter = SF.createListMoreReporter();
		cache.storelist.$reporter = reporter.container;
		cache.storelist.elements = reporter.elements;
	},

	bindStoreListViewEvents: function() {
		var SF = ACC.storefinder;
		var cache = SF._cache;
		// Event is triggered on AJAX response.
		cache.$storeFinderForm.on("response", function() {
			// Always reset the storelist view first
			SF.resetStoreListView();
			cache.storelist.total = cache.storesresults;
			cache.storelist.location = cache.location;

			if(cache.storesresults) {
				SF.createStoresListView();
				SF.createColumnListView();

				// Ensure view gets first X visible.
				SF.applyPaggination();
				SF.storeListReport();
				cache.storelist.$container.trigger("created");
			}
			else {
				// Error handling ??
			}
		});

		// Event is triggered when control activated is 'show more' button.
		cache.storelist.$container.on("click", "." + SF._constants.CLASS_SHOW_MORE_STORES, function () {
			SF._pagginationPadding++;
			SF.applyPaggination();
			SF.storeListReport();
		});

		// Event is triggered when list is created.
		cache.storelist.$container.on("created", function() {
			// Triggered when the storelist.$container contents have been built.
			// You can bind to this event to do other stuff knowing it exists.

			// Add anything new to DOM.
			cache.storelist.$container.prepend(cache.storelist.$reporter);
			cache.storelist.$container.append(cache.storelist.$control);
		});
	},

	// Grab additional items used for the Store Finder Page.
	cacheStoreFinderPageElements: function() {
		var cache = ACC.storefinder._cache;
		var c = ACC.storefinder._constants;
		cache.$internationalStores = $(c.SELECTOR_INTERNATIONAL_STORE_FORM);
		cache.$map = $(c.SELECTOR_STORE_MAP);
		cache.$filterContainer = $(c.SELECTOR_STORE_FINDER_FILTERS);
		cache.$filterClickAndCollect = $(c.SELECTOR_FILTER_CLICKANDCOLLECT);
		cache.$filterTkMaxx = $(c.SELECTOR_FILTER_TKMAXX);
		cache.$filterHomesense = $(c.SELECTOR_FILTER_HOMESENSE);
		cache.$header = $(c.SELECTOR_HEADER);

		// Set any text detected in JSP in cache.text.
		ACC.global.setDataElementText(cache.text, cache.$map);
	},

	bindFindInternationalStores: function() {
		var cache = ACC.storefinder._cache;

		cache.$internationalStores.on("submit", function(e) {
			e.preventDefault();
			var $select = $(this).find("button.dropdown-toggle");
			if($select.length) {
				if($select.data('value').includes('tkmaxx.com')){
					window.open($select.data('value') + '?clear=true', '_self');
				} else {
					window.open($select.data('value') + '?clear=true');
				}
			}
		});
	},

	bindMapViewEvents: function() {
		var SF = ACC.storefinder;
		var cache = SF._cache;
		var c = SF._constants;

		// Event is triggered on AJAX response.
		cache.$storeFinderForm.on("response", function() {
            ACC.global.addGoogleMapsApi("ACC.storefinder.drawMap");
            cache.$filterContainer.removeClass("initial");
            // re-run after map is rendered
            SF.applyAllFilters();

            if(!cache.storesresults) {
				cache.storelist.$container.empty();
				$('.storefinder-error').show();
			}
		});

		// Event is triggered when list is created.
		cache.storelist.$container.on("created", function() {
			SF.addStoresListMapMarkerLinks();
		});
    },

    applyFilter: function(filterType) {
        var SF = ACC.storefinder;
        var cache = SF._cache;

        if (cache.$filterContainer.length) {
            SF.filter(filterType);
        }

        SF._pagginationPadding = 1;
        SF.filterErrorMessageHandler();
        SF.applyPaggination();
    },

	bindFilterEvents: function() {
        var SF = ACC.storefinder,
            c = SF._constants,
            cache = SF._cache;

        cache.$filterClickAndCollect.on("change", function() {
			SF.view.candc = this.checked;
			SF.applyFilter(c.FILTER_CLICK_AND_COLLECT);
		});

		cache.$filterTkMaxx.on("change", function() {
			SF.view.tkmaxx = this.checked;
			SF.applyFilter(c.FILTER_TKMAXX_STORE);
		});

		cache.$filterHomesense.on("change", function() {
			SF.view.homesense = this.checked;
			SF.applyFilter(c.FILTER_HOMESENSE_STORE);
		});
	},

	// Filters are hidden on page load.
	// Also need to clean view between store searches.
	// Use this function to make any other changes as well.
	resetFilterView: function() {
		var SF = ACC.storefinder;
		var cache = SF._cache;
		var c = SF._constants;
        cache.$filterContainer.show();

        SF.filterErrorMessageHandler();

		// Quickfix: Seems to be a bug where TK Maxx filter doesn't think it is checked,
		// despite the response giving HTML that shows it is by  default.
        // Setting these as the on-load default view to be sure.
        if (cache.$filterContainer.length) {
            if (cache.$filterClickAndCollect.get(0).checked == false) {
                cache.$filterClickAndCollect.parent().removeClass(c.CLASS_CHECKED);
                cache.$filterClickAndCollect.get(0).checked = false;
            }

            if (!cache.$filterHomesense.get(0).checked) {
                cache.$filterHomesense.parent().removeClass(c.CLASS_CHECKED);
            }

            if (!cache.$filterTkMaxx.get(0).checked) {
                cache.$filterTkMaxx.parent().removeClass(c.CLASS_CHECKED);
            }

            // Record the initial filter states for later use.
            SF.view.candc = cache.$filterClickAndCollect.get(0).checked;
            SF.view.homesense = cache.$filterHomesense.get(0).checked;
            SF.view.tkmaxx = cache.$filterTkMaxx.get(0).checked;
        }
	},

	// Performs an auto lookup if page persistence conditions are met.
	autoSearch: function() {
		var SF = ACC.storefinder;
		var cache = SF._cache;
		var page = ACC.global.referrer();
		var query;
		if(page === "storedetails") {
			query = SF.storeDataQuery();
			if(query.indexOf("latitude") >= 0) {
				SF.userLocation(cache.text.location);
			}
			else {
				SF.userLocation(query.replace(/^.*?qry=([\w]+).*$/, "$1"));
			}

			SF.getStoreData(query);
		}
	},

	// Work out certain stats that can be of benefit to other areas.
	// Returns Object with various properties (added as cache.stats)
	updateStatsFromStores: function() {
		var SF = ACC.storefinder;
		var cache = SF._cache;
		var c = SF._constants;

		// CandC stats.
		SF.stats.candc.homesense = 0;
		SF.stats.candc.tkmaxx = 0;
		SF.stats.candc.total = 0;

		// General stats.
		SF.stats.stores.homesense = 0;
		SF.stats.stores.tkmaxx = 0;
		SF.stats.stores.total = cache.stores.length;

		// Update the calculations.
		for(var i=0; i<cache.stores.length; ++i) {
			if(cache.stores[i]["chainID"] === c.CHAIN_ID_TKMAXX) {
				SF.stats.stores.tkmaxx += 1;
			}
			else if (cache.stores[i]["chainID"] === c.CHAIN_ID_HOMESENSE) {
				SF.stats.stores.homesense += 1;
			}

			if (cache.stores[i]["clickAndCollect"] === "true") {
				SF.stats.candc.total += 1;
				if(cache.stores[i]["chainID"] === c.CHAIN_ID_TKMAXX) {
					SF.stats.candc.tkmaxx += 1;
				}
				else if (cache.stores[i]["chainID"] === c.CHAIN_ID_HOMESENSE) {
					SF.stats.candc.homesense += 1;
				}
			}
		}
	},

	drawMap: function() {
		var SF = ACC.storefinder;
		var cache = SF._cache;
		if (cache.$map.length) {
			// (Re)Initialise map
			cache.$map.empty();
			cache.$map.addClass("visible");
			cache.gmap = new google.maps.Map(cache.$map.get(0), {
				zoom: 10,
				zoomControl: true,
				maxZoom: 16,
				minZoom: 10,
				panControl: true,
				scrollwheel: false,
				streetViewControl: false,
				mapTypeId: google.maps.MapTypeId.ROADMAP,
				// Using existing (OOTB??) code here but we shouldn't be using hardcoded index.
				// Expect this to be improved with error handling code in TJX-1894
				center: new google.maps.LatLng(cache.stores[0].latitude, cache.stores[0].longitude)
			});

			SF._createMapInfoWindow();
			SF._addMapMarkers();
			SF._zoomToFit();
			SF._controlZoomOnScroll();

			// Required for GOOGLE MARKER LABEL FIX
			cache.googleMarkerLabelFixTilesLoadedListener = google.maps.event.addListener(cache.gmap, 'tilesloaded', function() {
				SF._googleMarkerLabelFix();
				// Remove listener to avoid duplicated efforts when new tiles are loaded (e.g. move map)
				google.maps.event.removeListener(cache.googleMarkerLabelFixTilesLoadedListener);
			});
			cache.googleMarkerLabelFixZoomChangedListener = google.maps.event.addListener(cache.gmap, 'zoom_changed', function() {
				SF._googleMarkerLabelFix();
				// Changing the zoom level limitation at runtime so that the user can zoom in / out further after the map is loaded
				cache.gmap.maxZoom = 22;
				cache.gmap.minZoom = 0;
			});

			// Workaround for keeping the zoom level in the minZoom: 10 - maxZoom: 16 threshold when doing multiple store searches without a page reload
			cache.googleMarkerLabelFixBoundsChangedListener = google.maps.event.addListener(cache.gmap, 'bounds_changed', function() {
				if (this.initialZoom == true) {
				    if (this.getZoom() > 16) {
				        this.setZoom(16);
				    }
				    if (this.getZoom() < 10){
				        this.setZoom(10);
				    }
				    this.initialZoom = false;
				}
				google.maps.event.removeListener(cache.googleMarkerLabelFixBoundsChangedListener);
			});

			cache.gmap.initialZoom = true;

			window.setTimeout(function() {
				SF._googleMarkerLabelFix();
			}, 500);
		}
	},

	// Add map information window to show store data.
	_createMapInfoWindow: function() {
		ACC.storefinder._cache.gmapinfowindow = new google.maps.InfoWindow({
			content: "",
			disableAutoPan: false,
			maxWidth: 300
		});
    },

    getMarkerToggleStatus: function(gmapMarker) {
        if (!gmapMarker || !gmapMarker.chainId) {
            return;
        }

        var SF = ACC.storefinder;
        var c = SF._constants;
        if ((SF.view.homesense && gmapMarker.chainId === c.CHAIN_ID_HOMESENSE) || (SF.view.tkmaxx && gmapMarker.chainId === c.CHAIN_ID_TKMAXX)) {
            return true;
        }
        return false;
    },

	/* GOOGLE MARKER LABEL FIX
		Google discourage having what they consider to be too many markers on a map.
		As a result, they only show the first character of any given Marker.label property.
		That means you'll only get 1-9 numbering showing correctly and clipping for double-digit numbers.
		StackOverflow chat claims a third-party MarkerWithLabel class provides a workaround but, at time
		of development, links to the page are returning 404.
		For a workaround to this problem, we are passing a single space character as the Marker.label.text
		property and calling _googleMarkerLabelFix(), when the map is ready, to inject label elements.
	*/
	_googleMarkerLabelFix: function() {
		var SF = ACC.storefinder;
		var cache = SF._cache;
		var c = SF._constants;
		var gmapmarkers = cache.gmapmarkers;
		var $container, containerLineHeight;
		cache.$gmnoprint = cache.$map.find(".gmnoprint");
		for(var i = 0; i < gmapmarkers.length; ++i) {
			if(!SF.getMarkerToggleStatus(gmapmarkers[i])) {
				gmapmarkers[i].visible = false;
				continue;
			}
			$container = cache.$gmnoprint.filter("[title='" + gmapmarkers[i].title + "']");
			if($container && $container.length && $container.find("." + c.CLASS_MARKER_LABEL).length < 1) {
				$container.addClass(c.CLASS_MARKER_HOLDER);
				$container.append(gmapmarkers[i].labelHtml);

				// Setting line-height
				containerLineHeight = $container.height();
				$container.find("." + c.CLASS_MARKER_LABEL).css('line-height', containerLineHeight - 14+'px');
			}
		}
	},

	_addMapMarkers: function() {
		var SF = ACC.storefinder;
		var cache = SF._cache;
		var marker;

		cache.gmapmarkers = new Array();
        for (var i = 0; i < cache.stores.length; ++i) {
            if (!cache.stores[i].chainID) {
                return;
            }
			// Create map marker and store reference (with extra data) on ACC.storefinder.
			marker = SF.createMapMarker(String((i+1)), cache.stores[i], cache.gmap);
			marker.setMap(cache.gmap);
			marker.setOpacity(1);
			cache.gmapmarkers.push(marker);
		}
	},

	createMapMarker: function(label, data, map) {
		var SF = ACC.storefinder;
		var c = SF._constants;
		var image = c.FOLDER_IMAGES + ((data.chainID == c.CHAIN_ID_TKMAXX) ? "TK_Pin_01.png" : "HS_Pin_01.png");
		var marker = new google.maps.Marker({
			position: new google.maps.LatLng(data.latitude, data.longitude),
			chainId: data.chainID,
			clickAndCollect: data.clickAndCollect,
			title: data.displayName,
			content: SF.createMapInformationContent(data),
			icon: {
				labelOrigin: new google.maps.Point(14,14),
				size: new google.maps.Size(29, 44),
				url: image
			},
			label: {
				text: label,
				color: '#ffffff',
				fontSize: '12px',
				fontWeight: 'bold'
			},
			zIndex: parseInt(label)
		});

		  // Add click event to open the infoWindow.
		  google.maps.event.addListener(marker, 'click', function () {
			 var SF = ACC.storefinder;
			 var cache = SF._cache;
			 var offset = cache.$header.offset().top + cache.$header.height();
			 var $content = $(this.content);
			 // Add GTM event tracking.
			 SF.addGtmStoreDetailsTracking($content, data, true);
			 cache.gmapinfowindow.setContent($content.get(0));
			 cache.gmapinfowindow.open(this.map, this);
			 // Anchoring to filters because the fixed header obscures some of the map.
			 ACC.global.scrollToElement(SF._constants.SELECTOR_STORE_MAP, offset);
		});

		return marker;
	},

	createMapInformationContent: function(data) {
		var SF = ACC.storefinder;
		var cache = SF._cache;
		var c = SF._constants;
		var html = '<div id="' + c.INFO_WINDOW_ID + '">';
		html += '<span class="name">' + data.displayName + '</span>';
		html += '<span class="distance">(' + parseFloat(data.formattedDistance).toFixed(2) + '&nbsp;' + cache.text.distanceMeasurement + ')</span>';
		html += '<span class="address">' + data.line1 + ',<br>' + (data.line2 ? data.line2 + ',<br>' : '') + '<span class="postcode">' + data.postalCode + '</span></span>';
		if(data.clickAndCollect === 'true') {
			html += '<p class="candc"><span class=" icon icon-mouse-pointer"></span>' + cache.text.cAndC + '</p>';
		}
		html += '<a class="details" href="' + ACC.config.encodedContextPath + data.url + '">' + cache.text.storeDetailsLinkText + '</a>&nbsp;';
		html += '<a class="directions" target="_blank" href="' + c.URL_GOOGLE_DIRECTIONS + data.latitude + ',' + data.longitude + '">' + cache.text.storeDetailsGetDirections + '</a>';
		html += '</div>';
		return html;
	},

	// Once Map and StoresList components are created,
	// we can add links to the map markers.
	addStoresListMapMarkerLinks: function() {
		var SF = ACC.storefinder;
		var cache = SF._cache;
		cache.storelist.$container.find("li").each(function(i){
			// Because the createColumnListView clones the items, we need to restrict numbering to desired range.
			var number = i < cache.storesresults ? i : i % cache.storesresults;
			var $showOnMap = SF.createShowOnMap(number);
			$(this).append($showOnMap);
		});
	},

	// Calculate the zoom level required based on coordinates added.
	// Suggest you do not change this unless you know what you're doing.
	_zoomToFit: function() {
		var cache = ACC.storefinder._cache;
		var bounds = new google.maps.LatLngBounds();
		for(var i=0; i<cache.stores.length; ++i) {
			bounds.extend(new google.maps.LatLng(cache.stores[i].latitude,cache.stores[i].longitude));
		}
		cache.gmap.fitBounds(bounds);
	},

	// Map scrolling cause UX issues so meeting Component Library requirement:
	// Scroll zoom functionlity:
	// 1. Should be disabled on the map
	// 2. Should become active once the user clicks in the map.
	// 3. (not specified) Disabled on clicking outside map to prevent UX issues.
	_controlZoomOnScroll: function() {
		var SF = ACC.storefinder;
		var cache = SF._cache;
		$(document).on("click", function() {
			cache.gmap.setOptions({ scrollwheel: false });
		});

		cache.$map.on("click", function(e) {
			cache.gmap.setOptions({ scrollwheel: true });
			e.stopPropagation();
		});
	},

	_getCurrentPosition: function(callback) {
		if(navigator.geolocation) {
			navigator.geolocation.getCurrentPosition(
				function (position) {
					callback(position);
				},
				function (error) {
					console.log("An error occurred... The error code and message are: " + error.code + "/" + error.message);
				}
			);
		}
		else {
			/*
			We should perhaps do something to acknowledge the user
			has disabled, or doesn't have, geolocation detection.
			*/
		}
	},

	// Get stores data by passing coordinates.
	getStoreDataByCoords: function() {
		var SF = ACC.storefinder;
		var cache = SF._cache;
		var data;
		SF.userLocation(cache.text.location);
		SF._getCurrentPosition(function(position) {
			SF.coords = position.coords;
			data = "qry=&latitude=" +  SF.coords.latitude + "&longitude=" + SF.coords.longitude + SF._cache.storeSearchExtraParams;
			SF.storeDataQuery(data);
			SF.getStoreData(data);
		});
	},

	// Get stores data by passing a string lookup.
	getStoreDataByEntry: function() {
		var SF = ACC.storefinder;
		var entry = $("#storelocator-query").val();
		var data;
		if(entry) {
			data = "qry=" + entry + SF._cache.storeSearchExtraParams;
			SF.userLocation(entry);
			SF.storeDataQuery(data);
			SF.getStoreData(data);
		}
	},

	// AJAX method to get the Stores data.
	getStoreData: function(data) {
        var SF = ACC.storefinder;
        var cache = SF._cache;

        // First prevent any already being fetched.
        if(SF._fetchingStores) {
            SF._fetchingStores.abort();
        }

        // Now get new data.
        SF._fetchingStores = $.ajax({
            url: cache.storesDataUrl,
            data: data,
            type: "GET",
            error: function(jqXHR, textStatus, errorThrown) {
                // If in checkout and the error status is 401 Unauthorized, then redirect to checkout.
                if(ACC.gtm.pageType == 'Checkout' && jqXHR.status == 401) {
                    window.location.href = '/checkout' ;
                }
            }
        }).done(function(response) {
            var cache = ACC.storefinder._cache;
            var json = $.parseJSON(response);

            cache.storesresults = json.total;
            cache.stores = json.data;

            ACC.gtm.callWhenLoaded('trackGtmStoreSearchResults', SF._cache.location, json.total);

            // bind to the triggered event to run your own functions.
            cache.$storeFinderForm.trigger("response");
            // update the robots tag with new data
            $('meta[name=robots]').attr('content', json.metaRobots);
        });
	},

	// Getter/Setter for location (used in error message)
	userLocation: function(message) {
		var cache = ACC.storefinder._cache;
		if(arguments.length && message) {
			cache.location = message;
		}
		return cache.location;
	},

	// Getter/Setter for store query lookup (used in page persistence).
	// @data (String) Querystring data that is sent to getStoreData.
	storeDataQuery: function(data) {
		return arguments.length && data ?
			window.localStorage.setItem("storesDataQuery", data)
			: window.localStorage.getItem("storesDataQuery");
	},

	createStoresListView: function() {
		var SF = ACC.storefinder;

		var cache = SF._cache;
		var $list = $("<ol class='column' role='radiogroup'>");
		var $li;

		// Create items.
		for(var i=0; i<cache.stores.length; ++i) {
			$li = $(SF.createStoreListItem((i+1), cache.stores[i]));
			SF.addGtmStoreDetailsTracking($li, cache.stores[i], false);
			$list.append($li);
		}

		// Clear and then repopulate
		cache.storelist.$container.empty();
		cache.storelist.$container.append($list);

		$(document).ready(function () {
			// Set aria-checked attribute on page load for the specific ol
			var storedValue = sessionStorage.getItem('selectCandCStore');
			var $radioInputValue = $(`.column input[type="radio"][value="${storedValue}"]`);
			var $radioInput = $('.column input[type="radio"]');

			if (storedValue) {
					$radioInputValue.attr('checked', true);
			}

			$radioInput.each(function () {
					updateAriaChecked($(this));
			});

			// Update aria-checked attribute on radio button change within the specific ol
			$radioInput.change(function () {
					const selectedValue = $(this).val();
					sessionStorage.setItem('selectedRadio', selectedValue);
					updateAriaChecked($(this));
			});

			function updateAriaChecked($radio) {
				// Set aria-checked attribute on the parent li of the selected radio
				if (!$radio.is(':checked')) {
						$radio.closest('li').removeAttr('aria-checked');
				} else {
						$radio.closest('li').attr('aria-checked', true);
				}
		}
	});

		$('.store-details-item .global-radio-button').click(function() {
			var $thisStoreList = $(this);
			var $radioInput = $thisStoreList.find('input[type="radio"]');

			for (const element of $list[0].children) {
				element.removeAttribute('aria-checked');
			}

			if (!$radioInput.is(':checked')) {
				$thisStoreList.attr('aria-checked', true);
			}
		})
	},

	 addGtmStoreDetailsTracking: function($html, data, bindStoreViewEvent) {
		 var $details = $html.find(".details");
		  $details.off("click.gtmtracking");
		  $details.on("click.gtmtracking", function() {
		   ACC.gtm.trackGtmStoreLocatorViewDetails(data);
		  });
		  var $moreDetails = $html.find(".moreDetails");
		  $moreDetails.off("click.gtmtracking");
		  $moreDetails.on("click.gtmtracking", function() {
		   ACC.gtm.trackGtmStoreLocatorViewDetails(data);
		  });
		  var $directions = $html.find(".directions");
		  $directions.off("click.gtmtracking");
		  $directions.on("click.gtmtracking", function() {
		   ACC.gtm.trackGtmStoreLocatorGetDirection(data);
		  });

		  //Trigger store select view
			if (typeof (data) != 'undefined' && data != undefined && bindStoreViewEvent) {
				if (":not(" + $details[0], $moreDetails[0], $directions[0] + ")") {
					var SF = ACC.storefinder;
					var cache = SF._cache;
					ACC.gtm.trackGtmStoreLocatorInteration(cache.location,cache.storelist.total,data);
				}
			}
		 },

	createStoreListItem: function(indicator, data) {
		var SF = ACC.storefinder,
			cache = SF._cache,
			address = SF.formatAddress(data.postalCode, data.line1, data.line2);

		return (
			'<li ' +
				'class="store-details-item chainID_' + data.chainID + ' ' + (data.clickAndCollect === 'true' && 'click-and-collect-store') +
				'" data-storeid="' + data.name +
				'" data-storename="' + data.displayName +
				'" data-clickandcollect="' + data.clickAndCollect +
				'" data-detail="' + ACC.config.encodedContextPath + data.url +
				'" role="' + "radio" +
			'">' +
				'<span class="indicator">' + indicator + '</span>' +
				'<div class="store-details">' +
					'<span class="name o-default-alt-body-bold">' + data.displayName + '</span>' +
					'<div class="comments o-default-alt-body-bold">' + data.description + '</div>' +
					'<span class="address u-spaced-top-10">' + address + '</span>' +
					'<span class="postcode">' + data.postalCode + '</span>' +
				'</div>' +
				'<span class="distance">' + parseFloat(data.formattedDistance).toFixed(2) + ' ' + cache.text.distanceMeasurement + '</span>' +
				'<a class="details" href="' + ACC.config.encodedContextPath + data.url + '">' + cache.text.storeDetailsLinkText + '</a>' +
				'<button class="moreDetails moreDetailsBtn" data-json="'+ ACC.config.encodedContextPath +'/store-api/details/' + data.name + '" data-bs-toggle="modal" data-bs-target="#extLinkPopup">' + cache.text.moreDetails + '</button>' +
			'</li>'
		);
	},

	/* Some corrective data formatting because what we're getting is not always the same.
	 * CSS was trying to inject commas but that didn't work due to differences.
	 * Basically this should give you an address with sensible comma separation.
	 * e.g. (some real data that we're fixing)
	 * data.line1 = "Colney Fields Shopping Park"
	 * data.line2 = "Barnet Road"
	 * data.postalCode = "AL2 1AB"
	 *
	 * data.line1 = "Staples Corner Retail Park, Geron Way,"
	 * data.line2 = "London  NW2 6LW"
	 * data.postalCode = "NW2 6LW"
	 *
	 * data.line1 = "57 King Street"
	 * data.line2 = ""
	 * data.postalCode = "W6 9HW"
	 *
	 * @postcode (String) Postcode value.
	 * @addressLine1 (String) Address line value.
	 * @addressLine2 (String) Address line value.
	 *
	 * Note: You can actually add as many additional address lines as you want because it will cope.
	 *
	 * Returns address string with commas.
	 **/
	formatAddress: function(postcode, addressLine1, addressLine2) {
		var address = [];
		var split, str;
		for(var i=1; i<arguments.length; ++i) {
			split = arguments[i].split(",");
			for(var a=0; a<split.length; ++a) {
				// Some data duplicated Postcode so we try to remove the unwanted.
				str = split[a].replace(postcode, "").trim();
				if(str) {
					address.push(str);
				}
			}
		}
		// Return as string with added commas.
		// If there's a postcode we want to add a final comma and space as well.
		return (address.join(", ") + (postcode ? ",&nbsp;": ""));
	},

	/* Since CSS column views aren't fully supported and reliable,
		adding a second cloned list. Using ARIA attributes, along
		with classes to make it accessible and simplify CSS. */
	createColumnListView: function($list) {
		var SF = ACC.storefinder;
		var columnHeight1 = 0;
		var columnHeight2 = 0;
		var $container = SF._cache.storelist.$container;
		var $newList = $container.find("ol");
		var $items = $newList.find("li");
		var desiredHalfwayPoint = Math.round($items.length / 2);
		$items.each(function(i) {
			var $this = $(this);
			$this.addClass(SF._constants.CLASS_CONCEALED); // Add initial concealed state for 'show more' functionality.
			if(i < desiredHalfwayPoint) {
				columnHeight1 += $this.outerHeight(true);
			}
			else {
				columnHeight2 += $this.outerHeight(true);
			}
		});
	},

	// Minimum required actions to reset the list view
	// e.g. after a successful store search builds a list,
	// and then a successive search brings no results.
	resetStoreListView: function() {
		var SF = ACC.storefinder;
		var cache = SF._cache;
		cache.storelist.$container.empty();
		cache.storelist.$control.addClass(SF._constants.CLASS_VISIBLE);
		cache.storelist.end = 0;
	},

	createShowOnMap: function(index) {
		var SF = ACC.storefinder;
		var cache = SF._cache;
		var $button = $('<button>' + cache.text.showOnMap + '</button>');
		$button.addClass("showOnMap");
		$button.attr("button");
		$button.on("click", function() {
			google.maps.event.trigger(cache.gmapmarkers[index], 'click');
			//ACC.gtm.trackGtmStoreLocatorInteration(SF._cache.location,cache.storelist.total,cache.stores[index]);
		});
		return $button;
	},

	// Works only with single column view.
	// Reveals the next chunk of list (<li> items), based on
	// set options.storesListViewLimit
	applyPaggination: function() {
		var SF = ACC.storefinder,
			cache = SF._cache,
			c = SF._constants,
			options = SF.options,
			$ol = cache.storelist.$container.find("ol");

		$ol.each(function () {
			var $list = $(this),
				$items = $list.find('li').not("." + c.CLASS_FILTERED);

			// Reveal next chunk up to the allowed limit.
	        $items.removeClass(c.CLASS_REVEALED + "," + c.CLASS_CONCEALED);
			$items.each(function(i) {
	            var $this = $(this);

				if (i < options.storesListViewLimit * SF._pagginationPadding) {
					$this.addClass(c.CLASS_REVEALED).removeClass(c.CLASS_CONCEALED);
				} else {
	                $this.removeClass(c.CLASS_REVEALED).addClass(c.CLASS_CONCEALED);
	            }
			});

			// Calculate whether to leave control visible.
			if($items.filter('.'+ c.CLASS_CONCEALED).length > 0) {
				cache.storelist.$control.addClass(SF._constants.CLASS_VISIBLE);
			} else {
				cache.storelist.$control.removeClass(SF._constants.CLASS_VISIBLE);
			}
		});

        cache.storelist.end = cache.storelist.$container.find('.' + c.CLASS_REVEALED).length;
	},

	// Dynamically updates the storelist report view.
	// e.g. Showing X-X of X near X
	storeListReport: function() {
		var SF = ACC.storefinder;
		var cache = SF._cache;
		var c = SF._constants;
		var list = cache.storelist;

		// Update all entries.
		list.elements.start.text(list.start);
		list.elements.end.text(list.end);
		list.elements.total.text(list.total);
		list.elements.location.text(list.location);

		// When all are visible, design requires we show "X of X" instead of "1-X of X".
		if(cache.storelist.end == cache.storelist.total) {
      if (!list.$container.hasClass(c.CLASS_SHOW_MORE_DONE)) {
        list.$container.addClass(c.CLASS_SHOW_MORE_DONE);
      }
		}
		else {
      if (list.$container.hasClass(c.CLASS_SHOW_MORE_DONE)) {
			  list.$container.removeClass(c.CLASS_SHOW_MORE_DONE);
      }
		}
	},

	// Works only with single column view.
	// Reveals the next chunk of list, based on
	// set options.storesListViewLimit
	createListMoreControl: function() {
		var SF = ACC.storefinder;
		var cache = SF._cache;
		var $button = $('<button>');

		$button.text(cache.text.showMoreStores);
		$button.addClass(SF._constants.CLASS_SHOW_MORE_STORES);
		$button.addClass(SF._constants.CLASS_VISIBLE);
		$button.attr("button");
		return $button;
	},

	// Showing X of X stores near Foo
	// Builds the required view to output the above stirng (or similar).
	createListMoreReporter: function() {
        var isCheckoutPage = $('.page-multiStepCheckoutSummaryPage').length > 0 ? true : false;
		var cache = ACC.storefinder._cache;
		var $container = $("<p></p>");
		var splitProperyStr = cache.text.showing.split(/{\d}/);
		var fields = ["start", "end", "total", "location"];
		var elements = {
			// These are holder elements for dynamic text
			// updated by the storelist 'more' event.
			start: $("<span></span>"),
			end: $("<span></span>"),
			total: $("<span></span>"),
			location: $("<span></span>")
		};

		// Build the component structure.
		$container.addClass("reporter");
		for(var i=0; i<splitProperyStr.length; ++i) {
			// Add the portion of properties text.
			$container.append("<span>" + splitProperyStr[i] + "</span>");
			if(fields.length) {
				// Then inject the required field.
				$container.append(elements[fields.shift()]);
			}
		}

        if (isCheckoutPage){
            return { elements: elements};
        } else {
            return {
                container: $container,
                elements: elements
            };
        }
	},

	filterErrorMessageHandler: function() {
		var SF = ACC.storefinder;

		// Clear errors.
		$('.storefinder-error').hide();

		// Assess whether any Click and Collect errors should show.
		if (SF.view.candc) {
		    // Cannot currently collect from Homesense
		    // Commented out as this keeps being changed to show or hide this message
		    /*if(SF.view.homesense) {
		    	$('.storefinder-error.homesense-click-and-collect-error').show();
		    }*/

		    if ((SF.stats.candc.tkmaxx === 0 && SF.stats.candc.homesense === 0) ||
		        (SF.view.tkmaxx && SF.stats.candc.tkmaxx === 0 && !SF.view.homesense) ||
		        (SF.view.homesense && SF.stats.candc.homesense === 0 && !SF.view.tkmaxx)) {
		        // No CandC stores.
		        $('.storefinder-error.candc').show();
		    }
		} else if (Object.keys(SF.stats.stores).length === 3 && !SF.stats.stores.tkmaxx && !SF.stats.stores.homesense) {
		    $('.storefinder-error.no-result').show();
		}

		// Assess whether any view TK Maxx errors should show.
		// If only TK Maxx store filter selected but no TK Maxx stores.
		if(SF.view.tkmaxx && SF.stats.stores.tkmaxx === 0 && !SF.view.homesense) {
			$('.storefinder-error.tjx-store').show();
		}

		// Assess whether any view Homesense errors should show.
		// If only Homesense store filter selected but no Homesense stores.
		if(SF.view.homesense && SF.stats.stores.homesense === 0 && !SF.view.tkmaxx) {
			$('.storefinder-error.homesense-error').show();
		}
	},

	// Handles separate filter actions.
	// @type (String) Filter type.
	filter: function(type) {
		var SF = ACC.storefinder;
		var cache = SF._cache;
		var c = SF._constants;
		switch(type) {
			case c.FILTER_CLICK_AND_COLLECT:
				// Reasses all markers and store list items.
				if (SF.view.candc == true) {
					cache.storeSearchExtraParams = "&criteria=cc";
				} else {
					cache.storeSearchExtraParams = "";
				}
				SF.getStoreDataByEntry();
				break;

			case c.FILTER_TKMAXX_STORE:
				// Reasses only the TXMaxx markers and store list items.
				SF.toggleMarkerVisibility.call(cache.$filterTkMaxx.get(0), c.CHAIN_ID_TKMAXX);
				SF.toggleStoreVisibility.call(cache.$filterTkMaxx.get(0), "chainID_" + c.CHAIN_ID_TKMAXX);
				break;

			case c.FILTER_HOMESENSE_STORE:
				// Reassess only the Homesense markers and store list items.
				SF.toggleMarkerVisibility.call(cache.$filterHomesense.get(0), c.CHAIN_ID_HOMESENSE);
				SF.toggleStoreVisibility.call(cache.$filterHomesense.get(0), "chainID_" + c.CHAIN_ID_HOMESENSE);
				break;

			default: // Nothing
		}
	},

	// Shows/hides Map Markers.
	// @type (String) ChainID value for markers.
	toggleMarkerVisibility: function(type) {
		var SF = ACC.storefinder;
		var markers = SF._cache.gmapmarkers;
		var filter = this;
		for(var i = 0; i < markers.length; ++i) {
			if (markers[i].chainId === type) {
				if (filter.checked && SF.clickAndCollectFilterAllows(markers[i]) && SF.getMarkerToggleStatus(markers[i])) {
					markers[i].setVisible(true);
					$(".showMoreStores").addClass('visible');
				}
				else {
					markers[i].setVisible(false);
					$(".showMoreStores").removeClass('visible');
				}
			}
		}
		window.setTimeout(function() {
			SF._googleMarkerLabelFix();
		}, 500);
	},

	// Shows/hides stores in list.
	// @type (String) CSS class value for list items.
	toggleStoreVisibility: function(type) {
		var SF = ACC.storefinder;
		var cache = SF._cache;
		var c = SF._constants;
		var $list = cache.storelist.$container;
		var filter = this;
		$list.find("li").each(function() {
			var $this = $(this);
			if($this.hasClass(type)) {
				if(filter.checked && SF.clickAndCollectFilterAllows($this)) {
					$this.removeClass(c.CLASS_FILTERED);
				}
				else {
					$this.addClass(c.CLASS_FILTERED);
				}
			}
		});
	},

	// Returns Boolean depending on Click and Collect filter state.
	// @utem (Marker || jQuery Object) Element that should be evaluated for click and collect.
	clickAndCollectFilterAllows: function(item) {
		var candcOnly = ACC.storefinder._cache.$filterClickAndCollect.get(0).checked;
		var isCandC = item.jquery ? item.attr("data-clickandcollect") : item.clickAndCollect;
		var allowed = true;
		if(candcOnly && isCandC != "true" ) {
			allowed = false;
		}

		return allowed;
	}

};
